interface MonitorsIconProps {
  size?: number;
  color?: string;
}

/**
 * Monitors Icon Component
 * @description A monitor with heartbeat/activity line representing system monitoring
 */
export const MonitorsIcon: React.FC<MonitorsIconProps> = ({ 
  size = 24, 
  color = 'currentColor' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={color}
        d="M21 2a1 1 0 0 1 1 1v3.5h-3.71l-1.328-3.987A.735.735 0 0 0 16.25 2a.76.76 0 0 0-.716.528l-2.257 7.336-.805-2.82a.75.75 0 0 0-.722-.544H8V8h3.185l1.344 4.706a.75.75 0 0 0 .713.544h.008a.75.75 0 0 0 .717-.53l2.311-7.513.76 2.28A.75.75 0 0 0 17.75 8H22v8a1 1 0 0 1-1 1h-7v3h4v2H6v-2h4v-3H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z"
      />
    </svg>
  );
};

export default MonitorsIcon;
